import schemes from './modules/schemes';
import fundList from './modules/fundList';
import login from './modules/login';
import customer from './modules/customer';
import investments from './modules/investment';
import registration from './modules/registration';
import banners from './modules/banners';
import utils from './utils';
import portfolioTransaction from './modules/portfolioTransaction';
import cart from './modules/cart';

const API = {
  scheme: schemes(),
  fundList: fundList(),
  downloadFetcher: (url: string, isPdf: boolean, options?: any) => utils.downloadFetcher(url, isPdf),
  customer: customer(),
  login: login(),
  investments: investments(),
  cart: cart(),
  portfolioTransaction: portfolioTransaction(),
  registration: registration(),
  banners: banners(),
  fetch: (url: string, options?: any) => utils.fetch(url, options),
};

// let API_OPTIONS = {};

export default API;
